import { render, staticRenderFns } from "./addReform.vue?vue&type=template&id=416f3268"
import script from "./addReform.vue?vue&type=script&lang=js"
export * from "./addReform.vue?vue&type=script&lang=js"
import style0 from "./addReform.vue?vue&type=style&index=0&id=416f3268&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports